import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  constructor(
    @Inject(DOCUMENT) private dom,
    private titleSvc: Title,
    private metaSvc: Meta
  ) {}

  generateSEOTags(title: string, description: string, url: string, image: string, keywords: string) {
    this.generateMetaTags(title, description, url, image, keywords);
    this.generateOpenGraphTags(title, description, url, image);
    this.generateTwitterTags(title, description, url, image);
  }

  generateMetaTags(title: string, description: string, url: string, image: string, keywords: string) {
    this.titleSvc.setTitle(title);
    this.metaSvc.updateTag({ name: 'description', content: description });
    if (keywords !== '') {
      this.metaSvc.updateTag({ name: 'keywords', content: keywords });
    }
    this.createCanonicalLink(url);
  }

  generateOpenGraphTags(title: string, description: string, url: string, image: string) {
    const websiteString = 'website';
    this.metaSvc.updateTag({ property: 'og:title', content: title });
    this.metaSvc.updateTag({ property: 'og:image', content: image });
    this.metaSvc.updateTag({ property: 'og:type', content: 'website' });
    this.metaSvc.updateTag({
      property: 'og:description',
      content: description,
    });
    this.metaSvc.updateTag({ property: 'og:url', content: url });
  }

  generateTwitterTags(title: string, description: string, url: string, image: string) {
    const index = url.indexOf('/info');
    const domainUrl = url.slice(0, index);

    this.metaSvc.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.metaSvc.updateTag({ name: 'twitter:url', content: url });
    this.metaSvc.updateTag({ name: 'twitter:domain', content: domainUrl });
    this.metaSvc.updateTag({ name: 'twitter:title', content: title });
    this.metaSvc.updateTag({
      name: 'twitter:description',
      content: description,
    });
    this.metaSvc.updateTag({ name: 'twitter:image', content: image });
  }

  createCanonicalLink(url: string) {
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.remove();
    }

    const link: HTMLLinkElement = this.dom.createElement('link');

    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    this.dom.head.appendChild(link);
  }
}
